import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"outlined":"","label":_vm.$t('Store'),"items":_vm.stores,"return-object":"","item-text":"name","item-value":"id","hide-details":"auto"},model:{value:(_vm.store),callback:function ($$v) {_vm.store=$$v},expression:"store"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }